import React, { useState } from "react";

const SanitaryNapkinCard = () => {
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - left - width / 2) / 20;
    const y = -(e.clientY - top - height / 2) / 20;
    setRotateX(y);
    setRotateY(x);
  };

  const handleMouseLeave = () => {
    setRotateX(0);
    setRotateY(0);
  };

  return (
    <div className="container mx-auto flex flex-col items-center bg-white rounded-lg px-4 pt-[100vh]">
      <h2 className="text-[#679729] font-bold text-4xl text-center">
        ORGANIC SANITARY PAD
      </h2>

      {/* Image with Mouse Hover Reaction */}
      <div
        className="w-full max-w-[1000px] flex items-center justify-center rounded-lg overflow-hidden"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{
          transform: `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
          transition: "transform 0.2s ease-out",
        }}
      >
        <img
          src="/images/product-image.png"
          alt="Organic Pad"
          className="w-full h-auto object-cover"
        />
      </div>

      <p className="text-[#679729] font-semibold text-3xl text-center mt-4">
        Organic Pad Ultra Thin XL
      </p>

      <a
        href="/products"
        className="bg-[#679729] text-white font-bold px-6 py-2 mt-4 rounded-full"
      >
        Buy Now
      </a>
    </div>
  );
};

export default SanitaryNapkinCard;
